import React from "react";
import { Route, elementsToRoutes } from './utils/components/router';

import Login from "./Customer/login";
import KundenaddressEditMA from "./Mitarbeiter/KundenaddressEditMA";
import KundenOrderDetailsMA from "./Mitarbeiter/KundenOrderDetailsMA";
import KundenEditMA from "./Mitarbeiter/KundenEditMA";
import KundenAddresseMA from "./Mitarbeiter/KundenAddresseMA";
import KundenDankeSeiteMA from "./Mitarbeiter/KundenDankeSeiteMA";
import TanAuth from "./pages/TanAuth";
import ErrorPage from "./pages/Error";
import CONFIG from "./config";
import { contextPath, contextMatchPath } from "./utils/functions";

/* special imports for noblemetals */

import EmpfehlungMA from "./pages/EmpfehlungMA";
import Home from "./home";
import Landingpage from "./pages/landingpage";

export const kundenRoutes = elementsToRoutes(
  <>
    <Route
      path="/"
      exact
      element={<Landingpage />}
    />
    <Route
      path={contextPath(CONFIG.LINK_HOME_KUNDE)}
      element={<Home />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_EMPFEHLUNG)}
      element={<EmpfehlungMA />}
      meta={{ active: CONFIG.isEdelmetallShop() }}
    />
    <Route
      path={contextPath(CONFIG.LINK_KUNDE_LOGIN)}
      element={<Login />}
    />
    <Route
      path={contextPath(CONFIG.LINK_KUNDE_TAN_AUTH)}
      exact
      element={<TanAuth loadData="true" />}
    />
    <Route
      path={contextPath(CONFIG.LINK_KUNDENDATEN_EDIT)}
      element={<KundenEditMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ADDRESSE_MA_EDIT)}
      exact
      element={<KundenaddressEditMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ADDRESSE_MA)}
      exact
      element={<KundenAddresseMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ORDER_DETAILS_MA)}
      element={<KundenOrderDetailsMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_DANKE)}
      element={<KundenDankeSeiteMA />}
    />
    <Route
      path={contextPath("/error")}
      element={<ErrorPage />}
    />
  </>
);
